import { collection, getDoc, getDocs } from "firebase/firestore";
import { db } from "../../../backend/firebaseConfig";
import { getIODetailsRef } from "../../Adviser/Tabs/IODetails/ioDetailsService";
import { toIdentifierArray } from "../../Adviser/Tabs/IODetails/ioIdentifierFormatters";

export const buildAdvisersByUserId = (advisers) => {
  const matches = {};
  advisers.forEach(({ adviserKey, userId }) => {
    toIdentifierArray(userId).filter(Number.isSafeInteger).forEach(id => {
      if (id <= 0) return;
      const key = String(id);
      if (!(key in matches)) matches[key] = adviserKey;
      else if (matches[key] !== adviserKey) matches[key] = null;
    });
  });
  return matches;
};

export const loadInstalledAppAdvisers = async () => {
  const snapshot = await getDocs(collection(db, "Authorized Members", "Advisers", "Data"));
  const advisers = await Promise.all(snapshot.docs.map(async adviser => {
    const details = await getDoc(getIODetailsRef(adviser.id));
    return { adviserKey: adviser.id, userId: details.data()?.userId };
  }));
  return buildAdvisersByUserId(advisers);
};
